import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import confirm from "../../../shared/modal/confirm";
import ScrollIntoView from "../../../shared/scroll-into-view/scroll-into-view";
import Loader from "./../../../shared/loader";
import {
    clearRedirect,
    deleteAnimal,
    fetchAnimal,
    updateAnimal,
    uploadImagesAndSaveAnimal,
    fetchAllSceneSettings,
    changeAnimalToProp
} from "./ducks/actions";
import Form from "./form";

function EditAnimal(props) {
    const filmId = props.filmId || props.match.params.filmId;
    const animalId = props.animalId || props.match.params.animalId;
    const {
        fetchAnimal,
        updateAnimal,
        changeAnimalToProp,
        uploadImagesAndSaveAnimal,
        deleteAnimal,
        loadingAnimal,
        animal,
        errors,
        fetchAllSceneSettings,
        allSceneSettings,
        embedded,
        onCloseForm
    } = props;

    const invalidIds = ["add", "overview"];

    useEffect(() => {
        fetchAllSceneSettings(filmId);
    }, []);

    useEffect(() => {
        if (invalidIds.indexOf(animalId) === -1) {
            fetchAnimal(filmId, animalId);
        }
    }, [filmId, animalId]);

    if (!embedded && props.redirect) {
        if (props.redirect.to === "list") {
            props.clearRedirect();
            const url = `/films/${filmId}/animals/`;
            return <Redirect to={url} />;
        } else if (props.redirect.to === "prop") {
            props.clearRedirect();
            const url = `/films/${filmId}/props/${props.redirect.id}/edit`;
            return <Redirect to={url} />;
        }
    }

    if (invalidIds.indexOf(animalId) > -1) {
        return null;
    }

    function renderLoading() {
        return <Loader />;
    }

    function renderAnimal(animal) {
        return (
            <ScrollIntoView
                className="blade-content widest"
                path="/films/:filmId/animals/:animalId/edit"
                loading={loadingAnimal}>
                <Form
                    errors={errors}
                    mode="edit"
                    filmId={filmId}
                    animalId={animal.id}
                    initialValues={animal}
                    loading={loadingAnimal}
                    onSubmit={onUpdateAnimal}
                    handleDelete={onDeleteAnimal}
                    onChangeAnimalToProp={onChangeAnimalToProp}
                    reduxFormValues={props.reduxFormValues}
                    acquisitionMethodEnum={props.acquisitionMethodEnum}
                    allSceneSettings={allSceneSettings}
                    onCloseForm={onCloseForm}
                    {...props}
                />
            </ScrollIntoView>
        );
    }

    function onUpdateAnimal(animal) {
        const files = animal.pictures || [];

        if ((files && files.length) > 0 || (animal.images && animal.images.length > 0)) {
            uploadImagesAndSaveAnimal(animal, files, false, filmId);
        } else {
            updateAnimal(filmId, animal);
        }
    }

    function onDeleteAnimal(animal) {
        confirm(() => deleteAnimal(filmId, animal), animal?.name);
    }

    function onChangeAnimalToProp(animal) {
        confirm(() => changeAnimalToProp(filmId, animal), null, `Are you sure you want to change ${animal.name} into a Prop?`, "Change Animal");
    };

    if (loadingAnimal) {
        return renderLoading();
    } else if (animal) {
        return renderAnimal(animal);
    }
    return null;
}

const mapStateToProps = (state) => {
    const { animalsState, commonState } = state;
    return {
        filmId: state.filmState.currentFilm.id,
        loadingAnimal: animalsState.loading,
        animal: animalsState.animal,
        errors: animalsState.errors,
        redirect: animalsState.redirect,
        acquisitionMethodEnum: state.enumState.acquisitionMethodEnum,
        allSceneSettings: animalsState.allSceneSettings,
        reduxFormValues: state.form.animal && state.form.animal.values
    };
};

export default withRouter(
    connect(mapStateToProps, {
        fetchAnimal,
        updateAnimal,
        deleteAnimal,
        clearRedirect,
        uploadImagesAndSaveAnimal,
        fetchAllSceneSettings,
        changeAnimalToProp
    })(EditAnimal)
);
